<tbody class="table-body">
  <ng-template [ngIf]="rows">
    <ng-template ngFor let-row [ngForOf]="rows | searchColumn: query | basicSearch: basicQuery | filterByDate: dateQuery" let-index="index">
      <sp-table-body-row
        *ngIf="!loading"
        [id]="row.id"
        [title]="row.title"
        [form]="row.form"
        [sendData]="row.sendData"
        [activeFormFieldIndex]="row.activeFormFieldIndex"
        [cells]="row.cells"
        [selected]="row.selected"
        [buttons]="row.buttons"
        [expandableTable]="row.expandableTable"
        [expanded]="row.expanded"
        [extendedRow]="row.extendedRow"
        [extended]="row.extended"
        [DataService]="DataService"
        [formGroup]="generateFormGroup(row)"
        [cancelTableForm]="cancelTableForm(row)"
        [withCheckbox]="withCheckbox"
        (propagateChecked)="getCheckedRow($event, row)"
        [class.--odd]="isOdd(index)"
      >
      </sp-table-body-row>
    </ng-template>
  </ng-template>
  <ng-content></ng-content>
</tbody>
